module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-dashboard-news-item is-clearfix"
  }, [_c('div', {
    staticClass: "lxm-dashboard-news-item__title"
  }, [(_vm.data.type === 'cf') ? [_c('span', {
    staticClass: "lxm-dashboard-news-item__type"
  }, [_vm._v("【筹款】")]), _vm._v(_vm._s(_vm.title) + "\n    ")] : (_vm.data.type === 'form') ? [_c('span', {
    staticClass: "lxm-dashboard-news-item__type"
  }, [_vm._v("【表单】")]), _vm._v(" "), (_vm.data.enablePrivateForm) ? _c('img', {
    staticClass: "lxm-item__lock",
    attrs: {
      "src": require("../../../images/main/lock.png")
    }
  }) : _vm._e(), _vm._v(_vm._s(_vm.title) + "\n    ")] : (_vm.data.type === 'activity_signup' || _vm.data.type === 'activity_signin') ? [_c('span', {
    staticClass: "lxm-dashboard-news-item__type"
  }, [_vm._v("【活动】")]), _vm._v(_vm._s(_vm.title) + "\n    ")] : [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "lxm-dashboard-news-item__content"
  }, [(_vm.data.type === 'cf') ? [_vm._v("\n       有\n       "), _c('span', {
    staticClass: "lxm-dashboard-news-item__number"
  }, [_vm._v(_vm._s(_vm.data.num))]), _vm._v("\n       笔收款，共计\n       "), _c('span', {
    staticClass: "lxm-dashboard-news-item__number"
  }, [_vm._v(_vm._s(_vm.data.money))]), _vm._v("\n       元\n    ")] : _vm._e(), _vm._v(" "), (_vm.data.type === 'form') ? [_vm._v("\n      有\n      "), _c('span', {
    staticClass: "lxm-dashboard-news-item__number"
  }, [_vm._v(_vm._s(_vm.data.num))]), _vm._v("\n      个表单提交\n    ")] : _vm._e(), _vm._v(" "), (_vm.data.type === 'activity_signup') ? [_vm._v("\n      有\n      "), _c('span', {
    staticClass: "lxm-dashboard-news-item__number"
  }, [_vm._v(_vm._s(_vm.data.num))]), _vm._v("\n      个报名提交\n    ")] : _vm._e(), _vm._v(" "), (_vm.data.type === 'activity_signin') ? [_vm._v("\n      有\n      "), _c('span', {
    staticClass: "lxm-dashboard-news-item__number"
  }, [_vm._v(_vm._s(_vm.data.num))]), _vm._v("\n      次活动签到\n    ")] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "lxm-dashboard-news-item__date-time is-pulled-left"
  }, [_vm._v(_vm._s(_vm.dateTime))]), _vm._v(" "), _c('div', {
    staticClass: "lxm-dashboard-news-item__detail is-pulled-right",
    on: {
      "click": _vm.viewClicked
    }
  }, [_c('img', {
    staticClass: "lxm-dashboard-news-item__view",
    attrs: {
      "src": require("../../../images/main/view.png")
    }
  }), _vm._v("\n    查看详情\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "lxm-dashboard-news-item__vertical-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "lxm-dashboard-news-item__circle",
    style: (_vm.circleStyle)
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-61301b60", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61301b60!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Dashboard/components/NewsItem.vue
// module id = 857
// module chunks = 0